import { render } from "./imgMark.vue?vue&type=template&id=4be2966a&scoped=true"
import script from "./imgMark.vue?vue&type=script&lang=js"
export * from "./imgMark.vue?vue&type=script&lang=js"

import "./imgMark.vue?vue&type=style&index=0&id=4be2966a&lang=less&scoped=true"

import exportComponent from "E:\\project\\eyes-system\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4be2966a"]])

export default __exports__